import { useIntl } from 'react-intl';

const useLanguage = (): string => {
  const { locale } = useIntl();

  return locale;
};

export { useLanguage };
